import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _process, _process$env, _process2, _process2$env;
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
// DOC: https://amplitude.com/docs/sdks/analytics/browser/browser-sdk-2
import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';
var isAmplitudeEnabled = ((_process = process) === null || _process === void 0 ? void 0 : (_process$env = _process.env) === null || _process$env === void 0 ? void 0 : _process$env.ENVIRONMENT) === 'prod' || ((_process2 = process) === null || _process2 === void 0 ? void 0 : (_process2$env = _process2.env) === null || _process2$env === void 0 ? void 0 : _process2$env.FORCE_AMPLITUDE) === 'true';
var sendEvent = function sendEvent(_ref) {
  var action = _ref.action,
    category = _ref.category,
    label = _ref.label,
    properties = _ref.properties;
  amplitude.track(action, {
    category: category,
    label: label,
    properties: properties
  });
};
var amplitudeIdentifyUser = function amplitudeIdentifyUser(userId) {
  var userProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var id = userId != null ? String(userId) : '';
  if (id.length < 5) return;
  amplitude.setUserId(id);
  var identifyEvent = new amplitude.Identify();
  Object.entries(userProperties).forEach(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      key = _ref3[0],
      value = _ref3[1];
    identifyEvent.set(key, value);
  });
  amplitude.identify(identifyEvent);
};
export default (function (_ref4, inject) {
  var app = _ref4.app;
  if (isAmplitudeEnabled) {
    // Every click and field change was tracked automatically (~2.6M events a
    // month) and no chart uses them; page views and $sendEvent events stay.
    amplitude.init(process.env.AMPLITUDE_API_KEY, {
      autocapture: {
        elementInteractions: false
      }
    });
    amplitude.add(sessionReplayPlugin({
      sampleRate: Number(process.env.AMPLITUDE_SAMPLE_RATE) || 0.1,
      forceSessionTracking: true,
      shouldInlineStylesheet: false,
      privacyConfig: {
        blockSelector: []
      }
    }));
    inject('amplitude', amplitude);
    inject('sendEvent', sendEvent);
    inject('amplitudeIdentifyUser', amplitudeIdentifyUser);
  } else {
    inject('sendEvent', function (_ref5) {
      var action = _ref5.action,
        category = _ref5.category,
        label = _ref5.label,
        properties = _ref5.properties;
      console.log("AMPLITUDE: Evento registrado en desarrollo: ".concat(action), "Categoria: ".concat(category), "Etiqueta: ".concat(label), "Propiedades:", properties);
    });
    inject('amplitudeIdentifyUser', function (userId, userProperties) {
      return console.log('AMPLITUDE: Identificación de usuario desactivada en desarrollo.');
    });
  }
});